module.exports = __webpack_public_path__ + "media/components/insights/asset-icons/operations-dcfe3d6c143bd71901a38908463a59dd.png";